(function () {
  const STORE_KEY = 'tc-recently-viewed-v1';

  function readItems() {
    try {
      const value = JSON.parse(window.localStorage.getItem(STORE_KEY) || '[]');
      return Array.isArray(value) ? value : [];
    } catch (_) {
      return [];
    }
  }

  function writeItems(items) {
    try {
      window.localStorage.setItem(STORE_KEY, JSON.stringify(items.slice(0, 8)));
    } catch (_) {}
  }

  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: currency || 'USD'
      }).format(Number(cents || 0) / 100);
    } catch (_) {
      return '$' + (Number(cents || 0) / 100).toFixed(2);
    }
  }

  function createCard(item, currency) {
    const li = document.createElement('li');
    li.className = 'tc-recently-viewed__item';
    const link = document.createElement('a');
    link.href = item.url;
    link.className = 'tc-recently-viewed__card';

    if (item.image) {
      const img = document.createElement('img');
      img.src = item.image;
      img.alt = item.title || '';
      img.loading = 'lazy';
      img.width = 360;
      img.height = 450;
      link.appendChild(img);
    }

    const title = document.createElement('strong');
    title.textContent = item.title || '';
    link.appendChild(title);

    const price = document.createElement('span');
    price.textContent = formatMoney(item.price, currency);
    link.appendChild(price);
    li.appendChild(link);
    return li;
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-tc-recently-viewed]').forEach(function (section) {
      const current = {
        handle: section.dataset.currentHandle,
        title: section.dataset.currentTitle,
        url: section.dataset.currentUrl,
        image: section.dataset.currentImage,
        price: Number(section.dataset.currentPrice || 0)
      };
      const previous = readItems().filter(function (item) { return item.handle && item.handle !== current.handle; });
      const grid = section.querySelector('[data-tc-recently-viewed-grid]');

      previous.slice(0, 4).forEach(function (item) {
        grid.appendChild(createCard(item, section.dataset.currency));
      });

      if (grid.children.length) section.hidden = false;
      writeItems([current].concat(previous));
    });
  });
})();
